import { render, staticRenderFns } from "./CategoryPanel.vue?vue&type=template&id=d6686476&scoped=true"
import script from "./CategoryPanel.vue?vue&type=script&lang=js"
export * from "./CategoryPanel.vue?vue&type=script&lang=js"
import style0 from "./CategoryPanel.vue?vue&type=style&index=0&id=d6686476&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6686476",
  null
  
)

export default component.exports